<template>
  <a-layout>
    <a-layout-content :style="{ backgroundColor: 'white' }">
      <a-form-model
        ref="ruleForm"
        :label-col="labelCol"
        :rules="rules"
        :wrapper-col="wrapperCol"
        :model="form"
      >
        <a-form-model-item label="选择资料包" prop="package_id">
          <a-select
            show-search
            v-model="name"
            placeholder="查询资料包"
            style="width: 200px"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @search="handleSearch"
            @change="handleChange"
          >
            <a-select-option v-for="item in packageArr" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="选择推广员">
          <!-- 联机选择器 -->
          <a-cascader
            style="width: 328px"
            :options="areaTree"
            :field-names="{ label: 'name', value: 'id', children: 'children' }"
            placeholder="请选择用户所属地区"
            :change-on-select="true"
            @change="
              (e) => {
                this.selectPath = e
              }
            "
          />
          <!-- 搜索 -->
          <a-button style="margin-left: 32px" @click="selectAdmin">
            搜索
          </a-button>
          <a-button style="margin-left: 8px" @click="selectAll">
            全部选中({{ adminList.length }}个)
          </a-button>

          <template v-if="adminList.length > 0">
            <div style="height: 120px;overflow-y: scroll;">
              <template v-for="item in adminList">
                <a-tag :key="item.id" @click="selectItem(item)">
                  {{ item.nickname }} ({{ item.username }}) -
                  {{ item.area_name }}
                </a-tag>
              </template>
            </div>
          </template>
          <template v-else>
            <a-empty :description="false" />
          </template>
          <a-table
            row-key="id"
            :data-source="selectList"
            :pagination="false"
            size="small"
            :scroll="{ y: 312 }"
            :locale="{ emptyText: '请选择推广成员' }"
          >
            <a-table-column title="姓名" data-index="nickname" />
            <a-table-column title="工号" data-index="username" />
            <a-table-column title="所属地区" data-index="area_name" />
            <a-table-column title="操作">
              <template slot-scope="record">
                <a-tag color="red" @click="removeAdmin(record.id)">
                  移 除
                </a-tag>
              </template>
            </a-table-column>
          </a-table>
        </a-form-model-item>
        <a-row type="flex" justify="center">
          <a-col :span="4">
            <a-button type="primary" @click="submit"> 提交</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { AdminByAreaApi } from '@/api'
import { get_area_tree } from '@/api/auth'
import { book_create_member, search_package_list } from '@/api/book'
export default {
  name: 'DetailAdd',
  data() {
    return {
      sub_list: [],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      areaTree: [],
      adminList: [],
      selectPath: [],
      selectList: [],
      form: {
        package_id: undefined,
        codeType: 1,
      },
      rules: {
        package_id: [
          { required: true, message: '请选择资料包', trigger: 'blur' },
        ],
      },
      list: [],
      packageArr: [],
      name: undefined,
    }
  },
  created() {
    this.id = parseInt(this.$route.query.id)
    if (!this.$HelperUtil.isEmpty(this.id)) {
      // 获取管理地区信息
      get_area_tree().then((res) => {
        if (res.code === 1) {
          this.areaTree = res.areaTree
        }
      })
    } else {
      this.goBack()
    }
  },
  methods: {
    handleChange(value) {
      this.form.package_id = value
    },
    handleSearch(value) {
      if (!this.$HelperUtil.isEmpty(value)) {
        search_package_list({
          name: value,
        }).then((res) => {
          if (res.code === 1) {
            this.packageArr = res.list
          } else {
            this.packageArr = []
          }
        })
      }
    },

    // 推广员相关
    selectAdmin() {
      if (this.selectPath.length === 0) {
        this.$message.warning('请选择地区')
        return false
      }
      AdminByAreaApi({ area_path: this.selectPath }).then((res) => {
        if (res.code === 1) {
          // 该地区下的用户
          this.adminList = res.admin_list
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 用户检测重复
    selectItem(item) {
      for (let i = 0; i < this.selectList.length; i++) {
        if (this.selectList[i]['id'] === item['id']) {
          this.$message.info({
            content: '重复添加用户已自动去除',
            key: 'unique_member',
          })
          return false
        }
      }
      this.selectList.push(item)
    },
    selectAll() {
      // 当前的成员列表
      if (this.adminList.length <= 0) {
        this.$message.warning('请先按地区查询推广人')
        return false
      }
      this.adminList.forEach((item) => {
        this.selectItem(item)
      })
    },
    removeAdmin(selected) {
      this.selectList = this.selectList.filter((item) => {
        return item.id !== selected
      })
    },

    submit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          book_create_member({
            id: this.id,
            package_id: this.form.package_id,
            // 用户相关
            activity_member_list: this.selectList,
          }).then((res) => {
            if (res.code === 1) {
              this.$message.success(res.msg)
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
  },
}
</script>

<style scoped>
.head-button-group span {
  width: 45%;
  margin: 0 6px 20px 6px;
  text-align: center;
  background: #f7f8f9;
  border-radius: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  font-weight: 700;
}
</style>
